import instance from './instances/file-service';
import constants from '@/constants';
export function signRequest(data) {
    return instance.post(constants.fileUploadURL, data);
}
